import * as React from 'react';
import { styled } from '../../../../styles';
import { Chip } from '../../../Chip/Chip';
import { SelectComponents } from '../../types';
import { Typography } from '../../../Typography/Typography';
import { RichTextPresenter } from './RichTextPresenter';

export const Chips: NonNullable<SelectComponents['Chips']> = ({
  selectedOptions,
  getTagProps,
  visibleElementsWhenSelected,
  isFocused,
  onBeforeChipClick,
  endText,
  limit: limitProps,
  maxWidth,
  loading
}): JSX.Element => {
  const limit = isFocused && !limitProps?.permanent ? 999 : (limitProps?.count ?? 999);

  return (
    <StyledDiv>
      {selectedOptions.slice(0, limit).map((currentOption, index) => {
        const props = getTagProps({ index });
        const hasIcon = !!visibleElementsWhenSelected?.icon && !!currentOption.icon;
        return (
          <StyledChip
            $hasIcon={hasIcon}
            $maxWidth={maxWidth}
            key={currentOption?.label || index}
            label={
              <RichTextPresenter
                selectedOption={currentOption}
                visibleElementsWhenSelected={visibleElementsWhenSelected}
                variant="chip"
                style={{ height: 24 }}
                loading={loading}
              />
            }
            color="default"
            onClickCapture={onBeforeChipClick}
            onDelete={
              !props.disabled
                ? (e) => {
                    props.onDelete(e);
                  }
                : undefined
            }
            size="small"
          />
        );
      })}
      {!!endText && <StyledTypography>{endText}</StyledTypography>}
    </StyledDiv>
  );
};
const StyledDiv = styled('div')`
  min-height: 38px;
  padding-top: 6px;  
  max-height: 150px;
  overflow-x: hidden;
  overflow-y: auto;
`;

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.tokens.colorOnSurfaceVariant};
  white-space: nowrap;
  display: inline-flex;
  margin-left: 4px;  

  .body1 {
    font-size: 13px;
    line-height: 23px;
  }
`;

const StyledChip = styled(Chip)<{ $hasIcon: boolean; $maxWidth?: number }>`
    margin-top: 1px;
    margin-right: 8px;
    max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : '100%')};
    & > .text {
        margin-left: ${({ $hasIcon }) => ($hasIcon ? -4 : 0)}px;
    }
`;
